import type {
  Product,
  ProductDraft,
  ProductExportResponse,
  ProductListParams,
  ProductListResponse,
} from '../../../types/product'

// TODO: Implement Flowhub product API gateway.
// Backend endpoint pattern: /flowhub/stores/:storeId/products (unconfirmed — verify with backend team).
// Flowhub uses a different category/classification taxonomy than Cova.
// Map response into the unified Product shape defined in src/types/product.ts.

export const flowhubProductApis = {
  getList: (_storeId: string, _params: ProductListParams): Promise<ProductListResponse> => {
    return Promise.reject(new Error('Flowhub product list: not yet implemented'))
  },

  getDetail: (_storeId: string, _productId: string): Promise<Product> => {
    return Promise.reject(new Error('Flowhub product detail: not yet implemented'))
  },

  update: (_storeId: string, _productId: string, _data: Partial<ProductDraft>): Promise<Product> => {
    return Promise.reject(new Error('Flowhub product update: not yet implemented'))
  },

  syncFromPos: (_storeId: string, _productId: string): Promise<Product> => {
    return Promise.reject(new Error('Flowhub product POS sync: not yet implemented'))
  },

  bulkUpdate: (_storeId: string, _ids: string[], _action: string): Promise<void> => {
    return Promise.reject(new Error('Flowhub product bulk update: not yet implemented'))
  },

  bulkAssign: (_storeId: string, _orgId: string, _productIds: string[], _payload: unknown): Promise<void> => {
    return Promise.reject(new Error('Flowhub product bulk assign: not yet implemented'))
  },

  exportCsv: (_storeId: string, _params: ProductListParams): Promise<ProductExportResponse> => {
    return Promise.reject(new Error('Flowhub product export: not yet implemented'))
  },
}
